import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-black uppercase tracking-wide transition-all duration-200 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0B1A0B]';
  const variants = {
    primary: 'bg-[#FF6B00] hover:bg-[#E65100] text-white shadow-[0_4px_14px_0_rgba(255,107,0,0.39)] hover:shadow-[0_6px_20px_rgba(255,107,0,0.23)] hover:-translate-y-0.5',
    secondary: 'bg-[#22C55E] hover:bg-[#16A34A] text-white shadow-lg hover:-translate-y-0.5',
    outline: 'border-2 border-[#FF6B00] text-[#FF6B00] hover:bg-[#FF6B00] hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const classes = cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className);
  // SI TIENE HREF (O ES EL LINK DEL CARRITO) → SE RENDERIZA COMO LINK
  if (href) {
    return <motion.a whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-201">
        {children}
      </motion.a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-202">
      {children}
    </motion.button>;
}